export default "__VITE_ASSET__DpmvsCoF__"